const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export function canonicalUwbRegistrationId(value: unknown): string {
  const registrationId = String(value || '').trim().toLowerCase()
  if (!UUID_PATTERN.test(registrationId)) {
    throw new Error('A valid UWB registration id is required.')
  }
  return registrationId
}

export function withUwbRegistration<T extends Record<string, unknown>>(
  registrationId: unknown,
  payload: T
): T & { registration_id: string } {
  return {
    ...payload,
    registration_id: canonicalUwbRegistrationId(registrationId),
  }
}

export function requireShopifyResourceId(value: unknown, resourceName: string): string {
  const resourceId = String(value ?? '').trim()
  if (!/^\d{1,32}$/.test(resourceId) || resourceId === '0') {
    throw new Error(`${resourceName} completed without a verified Shopify id. Reconcile before fulfillment.`)
  }
  return resourceId
}
